import Text from '../../../../atoms/Text';
import { IMobileFilterProps } from '../../../SearchTable/SearchTable';
import { ITableSort } from '../../../../molecules/Table/DesktopTable';

import './styles.scss';

export type TableSortMobileOption = {
  title: string;
  id: string;
  optionHigh: string;
  optionLow: string;
};

export type TableSortMobileData = {
  id: string;
  isSortedDesc: boolean;
};

interface ITableSortMobileProps extends IMobileFilterProps {
  sort: ITableSort;
  items: TableSortMobileOption[];
}

const TableSortMobile = ({
  sort,
  items,
  setSortValue,
}: ITableSortMobileProps) => {
  const onSortSelect = (id: string, isSortedDesc: boolean) => {
    setSortValue!({ id, isSortedDesc });
  };

  return (
    <>
      {items.map(({ title, id, optionHigh, optionLow }) => {
        const isActive = sort.id === id;

        return (
          <div key={id} className='sort_section'>
            <Text size={14} className='sort_section__title'>
              {title}
            </Text>
            <div
              className={`sort_option${
                isActive && sort.isSortedDesc ? ' sort_option--active' : ''
              }`}
              onClick={() =>
                onSortSelect(
                  id,
                  isActive && sort.isSortedDesc === true ? false : true
                )
              }
            >
              <div className='sort_option__content'>
                <div className='sort_option__icon icon-sort-arrow-down' />
                <Text
                  size={14}
                  className={`text--weight-500 ${
                    isActive && sort.isSortedDesc
                      ? 'text--grey-200'
                      : 'text--grey-400'
                  }`}
                >
                  {optionHigh}
                </Text>
              </div>
              {isActive && sort.isSortedDesc && (
                <div className='sort_option__icon sort_option__icon--active icon-check' />
              )}
            </div>
            <div
              className={`sort_option${
                isActive && !sort.isSortedDesc ? ' sort_option--active' : ''
              }`}
              onClick={() =>
                onSortSelect(
                  id,
                  isActive && sort.isSortedDesc === false ? true : false
                )
              }
            >
              <div className='sort_option__content'>
                <div className='sort_option__icon icon-sort-arrow-up' />
                <Text
                  size={14}
                  className={`text--weight-500 ${
                    isActive && !sort.isSortedDesc
                      ? 'text--grey-200'
                      : 'text--grey-400'
                  }`}
                >
                  {optionLow}
                </Text>
              </div>
              {isActive && !sort.isSortedDesc && (
                <div className='sort_option__icon sort_option__icon--active icon-check' />
              )}
            </div>
          </div>
        );
      })}
    </>
  );
};

export default TableSortMobile;
